<template>
  <div class="truckStatistics" ref="truckStatistics">
    <div class="home_time time" v-if="styleType == 'typeDark'">
      {{ now_time }}
    </div>

    <div class="innerBox">
      <div class="charts">
        <div class="bubble" v-for="(item, i) in bubbleData" :key="i">
          <div class="bubble_li">
            <div class="carName">{{ item.name }}</div>
            <div class="long">
              <div
                class="block"
                :class="'block' + i"
                :style="{ width: item.bai * 190 + 'px' }"
              ></div>
            </div>
            <div class="carCount number">{{ item.num }}</div>
          </div>
        </div>
      </div>
      <div class="allCount">
        <div class="circle"></div>
        <div class="today_all_count absolute_center">
          <div class="div1">今日车总</div>
          <div class="div2 number">{{ allCount }}</div>
          <div class="div3">台</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import getOpt from "./components/option.js";
import { dateFormat, unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'truckStatistics.vue',
      computedName: '运输车辆进出厂统计组件',
      customerId: this.$store.state.customerId,
      allCount: 0,
      data: [],
      bubbleData: [],
      chart: null,
      timer: null,
      now_time: "",
      styleType: "",
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      baseUrl: bmeConfig.baseUrl,
    };
  },
  //计算属性 类似于data概念
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let w = $(this.$refs.truckStatistics).outerWidth();
    let h = $(this.$refs.truckStatistics).outerHeight();

    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });

    this.getVideoConf();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    createChart() {
      for (var i = 0; i < this.bubbleData.length; i++) {
        let id = "main" + i;
        var chartDom = document.getElementById(id);
        this.chart = echarts.init(chartDom);
        let data = this.bubbleData[i];
        unwarp(this.chart).setOption(getOpt(data));
      }
    },
    async getVideoConf() {
      let videoConfData;
      if (this.isPublicCleanTransport) {
        videoConfData =  this.baseUrl + `/${CONFIG.requestName}`
      } else {
        let getVideoConf = CONFIG.requestName + this.$apiOpt.getVideoConf;
        videoConfData = await this.$apiUtils.get(getVideoConf, {
          customerId: this.customerId,
        });
        videoConfData = videoConfData.cleanTransportIp;
      }

      this.$store.commit("getVideoConfAction", videoConfData);
      this.getData();
    },
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.now_time = dateFormat("YYYY-mm-dd HH:MM", new Date());
      let findEntryAndExit =
        this.$store.state.cleanTransportIp + this.$apiOpt.findEntryAndExit;
      let data = await this.$apiUtils.get(findEntryAndExit, {
        startTime: dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 24 * 60 * 60 * 1000
        ),
        endTime: dateFormat("YYYY-mm-dd", new Date().getTime()),
      });
      // let data = [
      //   { count: 140, type: 5 },
      //   { count: 53, type: 6 },
      // ];
      if (data.length) {
        let all = 0;
        let max = 0;
        for (var i = 0; i < data.length; i++) {
          if (data[i].count > max) {
            max = data[i].count;
          }
          if (data[i].type == "3") {
            data[i].type = "国III";
          } else if (data[i].type == "4") {
            data[i].type = "国IV";
          } else if (data[i].type == "5") {
            data[i].type = "国V";
          } else if (data[i].type == "6") {
            data[i].type = "国VI";
          } else if (data[i].type == "99") {
            data[i].type = "新能源";
          }
          all += data[i].count;
        }
        this.allCount = all;
        let b = [];
        for (var i = 0; i < data.length; i++) {
          let a = {
            name: "",
            num: "",
            bai: "",
          };
          a.name = data[i].type;
          a.num = data[i].count;
          a.bai = (data[i].count / max).toFixed(2);
          b.push(a);
        }
        this.bubbleData = b;
      }

      this.timer = setTimeout(() => {
        this.getData();
      }, 5 * 60 * 1000);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.truckStatistics {
  width: 600px;
  height: 250px;
  .innerBox {
    @include bg-box(560px, 180px, "innerBg.png");
    display: flex;
    margin-top: 30px;
    padding-left: 10px;
    .charts {
      width: 340px;
      height: 100%;
      margin-right: 10px;
      padding: 20px 0px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .bubble {
        height: 22px;
        .bubble_li {
          width: 100%;
          display: flex;
          .carName {
            width: 99px;
            text-align: end;
            padding-right: 10px;
            font-size: 16px;
            color: #e4fcff;
          }
          .long {
            @include bg-box(190px, 22px, "lineBg.png");
            padding-left: 2px;
            .block {
              border-radius: 0px 2px 2px 0px;
              height: 20px;
            }
          }
          .carCount {
            width: 50px;
            text-align: end;
            padding-right: 5px;
            font-size: 16px;
            color: #e4fcff;
          }
        }
      }
    }
    .allCount {
      width: 200px;
      height: 100%;
      position: relative;
      .circle {
        @include bg-box(164px, 164px, "circle.png");
        top: 7px;
        left: 18px;
        position: absolute;
        animation: rotate 20s linear infinite;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-180deg);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
      .today_all_count {
        width: 65px;
        height: 85px;
        text-align: center;
        padding-top: 5px;
        .div1 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }
        .div2 {
          width: 100%;
          height: 28px;
          font-size: 28px;
          color: #99f5ff;
          line-height: 28px;
        }
        .div3 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
        }
      }
    }
  }
}
</style>
<style scoped>
.block {
  background: linear-gradient(270deg, #d7f1ff 0%, #79a9ff 100%);
}
.block0 {
  background: linear-gradient(270deg, #d7f1ff 0%, #79a9ff 100%);
}
.block1 {
  background: linear-gradient(270deg, #dcffe5 0%, #b6ffc6 100%);
}
.block2 {
  background: linear-gradient(270deg, #faebcb 0%, #f4d29c 100%);
}
.block3 {
  background: linear-gradient(270deg, #c4b0ff 0%, #9278ff 100%);
}
.block4 {
  background: linear-gradient(270deg, #ffb0b0 0%, #ff7878 100%);
}
</style>
